var map = {
	"./qld/ancestry": 538,
	"./wa/ancestry": 544
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 503;


//////////////////
// WEBPACK FOOTER
// ../data ^\.\/.*\/ancestry$
// module id = 503
// module chunks = 0